import React, { Component } from "react";
import TimeDiff from "../../helpers/TimeDiff";

class NewsLetterTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <table className="a-table">
        <thead>
          <tr>
            <td>Newsletter Title</td>
            <td>Newsletter</td>
            <td>Time Posted</td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          {this.props.posts.length > 0 &&
            this.props.posts.map(p => (
              <tr key={p.post_id} id={`row${p.post_id}`}>
                <td style={{ textAlign: "left" }}>
                  {
                    p.post_title}
                </td>
                <td>{p.main_post}</td>
                <td>
                  {" "}
                  <TimeDiff date={p.created_at} />{" "}
                </td>
                <td>
                  <button
                    className={`a-table-retrieve`}
                    data-id={p.post_id}
                    onClick={this.props.sendNewsletter}
                  >
                    {p.sent === 1 ? `Already Sent` : `Send Newsletter`}
                  </button>
                </td>
                <td>
                  <button
                    className={`a-table-delete`}
                    data-id={p.post_id}
                    onClick={this.props.postDelete}
                  >
                    {`Delete`}
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  }
}

export default NewsLetterTable;
